<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<p style=" font-family:Calisto MT; text-align: center; font-weight:bold; font-size:18pt; letter-spacing:1px; padding-top:90px; padding-bottom:20px;">About the Author</p>
<p style="text-indent:0px;">An accountant, always willing to support/help others, keen in wildlife conservation, helps to fight cancer, loves gardening and growing exotic plants, including orchids, has various pets, loves writing, dancing, Lau Gar Kung Fu, ancient history, various music and entomology.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0cf10ac8